import bookSelectors from './bookSelectors';
import bookForSelectors from './bookForSelectors';
import attendeesSelectors from './attendeesSelectors';

export default {
  ...bookSelectors,
  ...bookForSelectors,
  ...attendeesSelectors
};
